
      <main class="bggraddiv">
        <div class="container">
            
            <div class="row justify-content-center 
            pt-5 pb-5 mb-0 
            ps-3 pe-3
            ps-sm-0 pe-sm-0
            ps-md-0 pe-md-0
            ps-lg-0 pe-lg-0
            g-0" *ngIf="page=='login'">
                <div class="col-sm-12 col-md-12 col-lg-9 divshadow containerlogin">
                    <div class="row g-0">
                        <div class="col-sm-12 col-md-6 col-lg-6 bglogin">
                            <!-- <div class="row">
                                <div class="col-3"></div>
                                <div class="col-9">
                                    <div class="py-5 my-3 text-end">
                                        <img src="/assets/auth/login/title.png" class="me-2" data-aos="fade-up">
                                        <img src="/assets/auth/login/subtitle.png" class="me-3" data-aos="fade-up" data-aos-delay="200">
                                    </div>
                                </div>
                            </div> -->
                        </div>
                        <div class="col-sm-12 col-md-6 col-lg-6 bg-white bginputlogin">
                            <div class="paddinglogin divlogin cd-content">
                                <div class="text-center mb-3 pb-2">
                                    <a href="/">
                                    <img src="/assets/images/logofh-cepetdapet.png" style="width: 100%; max-width: 220px;">
                                    </a>
                                </div>
                                

                                <h3 class="pb-0 mb-0 texttitlelogin f2 pb-1"><strong>{{'login.welcome_back' | translate}}</strong></h3>
                                <p class="pt-0 mt-0 mb-4 textlogin f2">{{'login.login_your_account' | translate}}</p>

                                <form *ngIf="!isLoggedIn" name="form" (ngSubmit)="f.form.valid && onSubmit()" #f="ngForm" novalidate >
                                    <div class="form-group mb-3">
                                        <label for="email" class="cdc1 text-capitalize">{{'login.email' | translate}} <font class="text-danger">*</font></label>
                                        <input
                                        type="text" placeholder="{{'login.email_placeholder' | translate}}"
                                        class="form-control"  [ngClass]="{ 'is-invalid': f.submitted && email?.errors }" 
                                        name="email"
                                        [(ngModel)]="form.email"
                                        required
                                        #email="ngModel"
                                        />
                                        <div
                                        class="errtxt"
                                        role="alert"
                                        *ngIf="email.errors && f.submitted"
                                        >
                                        {{'login.required_email' | translate}}
                                        </div>
                                    </div>
                                    <div class="form-group mb-3">
                                        <label for="password" class="cdc1 text-capitalize">{{'login.password' | translate}} <font class="text-danger">*</font></label>
                                        <!-- <input
                                        type="password" 
                                        placeholder="Type your password"
                                        class="form-control"
                                        name="password"
                                        [(ngModel)]="form.password"
                                        required
                                        minlength="8"
                                        maxlength="64"
                                        #password="ngModel"
                                        /> -->


                                        <div class="input-group mb-0">
                                            <input type="{{(showPass)?'text':'password'}}" 
                                            placeholder="{{'login.password_placeholder' | translate}}"
                                            class="form-control passwordeyes pointer"
                                            name="password"
                                            [(ngModel)]="form.password"
                                            required
                                            minlength="8"
                                            maxlength="64"
                                            [ngClass]="{ 'is-invalid': f.submitted && password?.errors }" 
                                            #password="ngModel">
                                            <span class="input-group-text eyesicon pointer" [ngClass]="{ 'is-invalid': f.submitted && password?.errors }" >
                                                <i (click)="showPassword()" *ngIf="showPass" class="bi bi-eye opacity-50"></i>
                                                <i (click)="showPassword()" *ngIf="!showPass" class="bi bi-eye-slash opacity-50"></i>
                                            </span>
                                          </div>


                                        <div
                                        class="errtxt"
                                        role="alert"
                                        *ngIf="password.errors && f.submitted"
                                        >
                                            <div *ngIf="password.errors.required">
                                                {{'login.required_password' | translate}}
                                            </div>
                                            <div *ngIf="password.errors.minlength">
                                                {{'login.minimum_password' | translate}}
                                            </div>
                                        </div>
                                    </div>
                                    <div class="form-group">

                                        <div class="row">
                                            <div class="col-12">
                                                <div class="form-check">
                                                    <input #checkboxRemember class="form-check-input" type="checkbox" [(ngModel)]="rememberMe" [ngModelOptions]="{standalone: true}" id="flexCheckChecked" (change)="changeChecked(checkboxRemember.checked)">
                                                    <label class="form-check-label rememberme" for="flexCheckChecked">
                                                    {{'login.remember_me' | translate}} 
                                                    </label>
                                                </div>
                                            </div>
                                        </div>


                                    </div>
    
                                    <div class="form-group pt-3 mt-3" *ngIf="requiredCapcha">
                                        <re-captcha
                                        [(ngModel)]="cpatchaText"
                                        name="captcha"
                                        required
                                        siteKey="{{config.captchaKey}}"
                                        ></re-captcha>
    
                                        <div class="errmsg"  [hidden]="f?.form?.valid">
                                            Captcha is required
                                        </div>
    
                                    </div>
                                    
    
                                    <div class="form-group mt-3">
                                        <button *ngIf="!pageloading" class=" btn btn-secondary btn-block w-100 cdbtn2 pt-2 pb-2 f2">
                                        {{'menu.login' | translate}}
                                        </button>
                                        <button *ngIf="pageloading" class=" btn btn-secondary btn-block w-100 cdbtn2 pt-2 pb-2 f2" disabled>
                                        Loading..
                                        </button>
                                        
                                    </div>
                                    <div class="form-group mt-3 text-center">
                                        <div class="col-12">
                                        
                                        </div>
                                        <div class="col-12 tb">
                                            <p class="cdc1 mb-1">
                                                <a href="/regis">{{'login.dont_have_account' | translate}}  <strong><u>{{'menu.regis' | translate}}</u></strong></a>
                                            </p>
                                            <p class="cdc1"><a class="pointer" (click)="showdiv('forgotpassword')">{{'login.forgot_password' | translate}}</a></p>
                                            <!-- <p class="c1 rememberme">
                                                <strong>
                                                Do not have account yet? 
                                            <a href="regis" class="c1 rememberme">Register here</a> </strong></p>     -->
                                        </div>

                                    </div>
                                    <div class="form-group">
                                        <div
                                        class="alert alert-danger mt-1 p-2 f2 text-center"
                                        role="alert"
                                        *ngIf="f.submitted && isLoginFailed"
                                        >
                                        {{ errorMessage }}
                                        </div>
                                    </div>
                                </form> 
                            </div>
                               
                        </div>
                    </div>
                </div>
            </div>
            <div class="row justify-content-center pt-5 pb-5 mb-0 g-0" *ngIf="page=='forgotpassword'">
                <div class="col-sm-12 col-md-12 col-lg-9 divshadow containerforgot">
                    <div class="row g-0">
                        <div class="col-sm-12 col-md-6 col-lg-6 bgforgot"></div>
                        <div class="col-sm-12 col-md-6 col-lg-6 bg-white bginputforgot">

                            <div class="paddinglogin divlogin cd-content">
                                
                                <div class="text-center mb-3 pb-2">
                                    <a href="/">
                                    <img src="/assets/images/logofh-cepetdapet.png" style="width: 100%; max-width: 220px;">
                                    </a>
                                </div>
                                

                                <h3 class="f2 pb-0 mb-0 texttitlelogin pb-1"><strong>{{'login.forgot_password_title' | translate}}</strong></h3>
                                <p class="pt-0 mt-0 mb-4 textlogin f2">{{'login.forgot_password_desc' | translate}}</p>

                                <form [formGroup]="forgotForm" (ngSubmit)="submitforgot()">
                                    <div class="form-group mb-3 pb-3">
                                        <label for="email" class="cdc1 text-capitalize">Email</label>

                                        <input type="text" [(ngModel)]="ValEmail" formControlName="email" max="254" class="form-control" [ngClass]="{ 'is-invalid': submitedforgot && g?.email?.errors }" />
                                        <div
                                        class="errtxt"
                                        role="alert"
                                        *ngIf="submitedforgot && g?.email?.errors"
                                        >
                                        <div *ngIf="g?.email?.errors?.required">{{'login.required_email' | translate}}</div>
                                        <!-- <div *ngIf="f?.email?.errors?.email">Email must be a valid email address</div> -->
                                        <div *ngIf="g?.email?.errors?.pattern">{{'login.invalid_email' | translate}}</div>
                                        </div>


                                    </div>

    
                                    <div class="form-group mt-3">
                                        <button *ngIf="!pageloading" class="f2 btn btn-secondary btn-block w-100  pt-2 pb-2 cdbtn2 text-capitalize">
                                        {{'text.send' | translate}}
                                        </button>
                                        <button *ngIf="pageloading" class="f2 btn btn-secondary btn-block w-100  pt-2 pb-2 cdbtn2" disabled>
                                        Loading..
                                        </button>
                                        
                                    </div>
                                    <div class="form-group mt-3 text-center">
                                        <div class="col-12">
                                            <!-- ValEmail : {{ValEmail}} -->
                                        </div>
                                        <div class="col-12 tb">
                                            <p class="f2 rememberme cdc1 text-capitalize pointer" (click)="showdiv('login')">
                                                {{'login.already_have_accout' | translate}} 
                                            <strong class="f2 rememberme pointer cdc1 text-capitalize">{{'login.login_here' | translate}}</strong></p>    
                                        </div>

                                    </div>
                                    <div class="form-group">
                                        <div
                                        class="alert alert-danger mt-1 p-2"
                                        role="alert"
                                        *ngIf="submitedforgot && isForgotFailed!==''"
                                        >
                                        {{ errorMessage }}
                                        </div>
                                    </div>
                                </form> 
                            </div>
                               
                        </div>
                    </div>
                </div>
            </div>


    <div *ngIf="forgotcompleted">


        <div class="row justify-content-md-center pt-5 pb-5">

            <div class="col-auto">
              
              <div class="card divshadow mt-5 mb-5 border-0">
                <div class="card-body p-0 border-0">
                    <div class="card-line-danger" *ngIf="!forgotresstatus"></div>
                    <div class="card-line" *ngIf="forgotresstatus"></div>

                    <div class="p-5">
                        <div class="text-center">
                            <img *ngIf="!forgotresstatus" class="draftimgicon" src="/assets/images/icons/Group 518-2@2x.png" >
                            <img *ngIf="forgotresstatus" class="draftimgicon" src="/assets/images/icons/Group 518@2x.png">
                        </div>
                        <br>
                        <div class="row justify-content-center mb-3">
                            <div class="col-9 text-center ">
                                <h3 class="f1" *ngIf="!forgotresstatus">Error!</h3>
                                <h3 class="f1" *ngIf="forgotresstatus">Success!</h3>
                                <!-- <h5 class="card-title f1l">Sorry, an error occured. The token is expired or invalid.</h5> -->
                                <p class="mt-0 mb-4">{{forgotresmsg}}</p>
                            </div>
                        </div>
                        <div class="text-center">
                            <a href="/" *ngIf="!forgotresstatus" class="text-center f1 btn btn-secondary btn-block w-50 btn-failed pt-2 pb-2">Back</a>
                            <a *ngIf="forgotresstatus" class="btn btn-secondary f1 btn-success fw-bold pt-2 pb-2 pe-5 ps-5" data-bs-dismiss="modal" href='/'>Done</a>
                        </div>
                    </div>


                </div>
              </div>    
            </div>  
        </div>  


    </div>





            <div class="bggradlayer"></div> 
        </div>
        
                          
                                           
        
                        
      </main>
<div class="">
<app-footer></app-footer>
</div>